const countryUSOnly: { [key: string]: string } = {
  US: 'United States',
};

export default countryUSOnly;
